import { Pipe, PipeTransform } from '@angular/core';

import { SubscriptionPlan, SubscriptionStatus } from '@vi-iot/client';

import { BookingSubscription, BOOKING_SUBSCRIPTIONS_FILTER_TYPE } from '@store';

@Pipe({
  name: 'sortBookings',
  standalone: true,
})
export class SortBookingsPipe implements PipeTransform {
  transform(
    bookings: BookingSubscription[],
    options: {
      filter: BOOKING_SUBSCRIPTIONS_FILTER_TYPE;
      includeExpiredSubscriptions: boolean;
    }
  ): BookingSubscription[] {
    if (!options.includeExpiredSubscriptions) {
      bookings = bookings.filter(
        (booking) => booking.status?.toLowerCase() !== SubscriptionStatus.expired
      );
    }

    switch (options.filter) {
      case BOOKING_SUBSCRIPTIONS_FILTER_TYPE.PRO:
        bookings = bookings.filter((booking) => booking.plan === SubscriptionPlan.Pro);
        break;
      case BOOKING_SUBSCRIPTIONS_FILTER_TYPE.PLUS:
        bookings = bookings.filter((booking) => booking.plan === SubscriptionPlan.Plus);
        break;
      case BOOKING_SUBSCRIPTIONS_FILTER_TYPE.TRIAL:
        bookings = bookings.filter((booking) => booking.trial);
        break;
    }

    return bookings.sort(
      (a, b) => new Date(b.subscriptionDate).getTime() - new Date(a.subscriptionDate).getTime()
    );
  }
}
